<template>
  <div class="flex flex-col relative gap-y-8 p-5 pb-32">
    <div class="container mx-auto flex flex-col m-5 gap-y-8">
      <BreadCrumbs :crumbs="breadcrumbItems" />

      <Title :title="'Add service'" />

      <Services />
    </div>

    <PriceBar
      :monthlyRecurringCost="totalMonthlyCost"
      :itemCount="addedServices.length"
      :summary="true"
    />
  </div>
</template>

<script>
import Services from "@/components/Services.vue";
import BreadCrumbs from "@/components/BreadCrumbs.vue";
import Title from "@/components/Title.vue";
import PriceBar from "@/components/PriceBar.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    BreadCrumbs,
    Title,
    PriceBar,
    Services,
  },
  data() {
    return {
      breadcrumbItems: [
        { text: "Home", to: "/" },
        { text: "WX-One Pricing Calculator", to: "/calculator" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      addedServices: "services/addedServices",
      totalMonthlyCost: "services/totalMonthlyCost",
    }),
  },
  created() {
    // Warm the catalog so the configuration pages open without a spinner.
    this.$store.dispatch("pricing/fetchCatalog").catch(() => {});
  },
};
</script>

<style lang="postcss" scoped>
.form-input {
  @apply pl-9;
}
</style>
